import React from "react";
import { useLocation } from "react-router-dom";
import appConfig from "../config/appConfig.json";
import styled from "styled-components";

const DetailImg = styled.img.attrs({
  className: "center-image",
})`
  width: 100%;
  height: 470px;
  object-fit: contain;
  @media (max-width: 576px) {
    height: auto;
  }
`;
export default function NFTDetail() {
  const { state } = useLocation();

  // const { imageURL, description, title } = state;

  const { imageURL, title } = state;

  return (
    <div>
      <div className="wrapper">
        <div className="section hero wf-section">
          <div className="container w-container">
            <div className="w-layout-grid _2-grid">
              <DetailImg
                id="w-node-_1a700ac1-51c5-d994-21de-a73c47c5f273-6edb158d"
                loading="lazy"
                src={imageURL}
                alt={title}
              />
              <div className="text-box">
                <h1 className="heading h2">
                  {/* Avatar 23 */}
                  {title}
                </h1>
                <p className="paragraph medium">
                  {/* {description} */}A character from Avatar Squad. Avatar
                  Squad is a drop of custom illustrative characters aiming to
                  express culture, personality and individuality. Through
                  hand-drawn hairstyles, facial expressions, and clothes, Avatar
                  Squad embraces what it means to be on the common ground but
                  having a sense of individuality.
                </p>
                <div className="spacer _16" />
                <a
                  href={appConfig.openSea}
                  target="_blank"
                  className="button w-button"
                  rel="noreferrer">
                  OpenSea'de Görüntüle
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
